import {lazy, FC, Suspense} from 'react'
import {Route, Routes, Navigate} from 'react-router-dom'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import {DashboardWrapper} from '../pages/dashboard/DashboardWrapper'
import {MenuTestPage} from '../pages/MenuTestPage'
import {getCSSVariableValue} from '../../_metronic/assets/ts/_utils'
import BusinessPage from '../modules/kyc/business/BusinessKybPage'
import AdministrationPage from '../pages/administration/AdministrationPage'

const PrivateRoutes = () => {
    const BuilderPageWrapper = lazy(() => import('../pages/layout-builder/BuilderPageWrapper'))
    const ProfilePage = lazy(() => import('../modules/profile/ProfilePage'))
    const AccountPage = lazy(() => import('../../app/modules/accounts/AccountPage'))
    const PersonKycPage = lazy(() => import('../modules/kyc/PersonKycPage'))
    const CompanyKycPage = lazy(() => import('../modules/kyc/company/CompanyKycPage'))
    const PersonOnboardingPage = lazy(() => import('../../app/modules/onboarding/person/PersonOnboardingPage'))
    const CompanyOnboardingPage = lazy(() => import('../../app/modules/onboarding/company/CompanyOnboardingPage'))

    return (
        <Routes>
            <Route element={<MasterLayout/>}>
                <Route path='auth/*' element={<Navigate to='/kyc/overview'/>}/>

                {/* Pages */}
                <Route path='dashboard' element={<DashboardWrapper/>}/>
                <Route path='builder' element={<BuilderPageWrapper/>}/>
                <Route path='menu-test' element={<MenuTestPage/>}/>
                {/* Lazy Modules */}
                <Route
                    path='kyc/*'
                    element={
                        <SuspensedView>
                            <PersonKycPage/>
                        </SuspensedView>
                    }
                />
                <Route
                    path='kyb/*'
                    element={
                        <SuspensedView>
                            <BusinessPage/>
                        </SuspensedView>
                    }
                />
                <Route
                    path='administration/*'
                    element={
                        <SuspensedView>
                            <AdministrationPage />
                        </SuspensedView>
                    }
                />
                <Route
                    path='account/*'
                    element={
                        <SuspensedView>
                        <AccountPage />
                        </SuspensedView>
                    }
                />

                {/* Page Not Found */}
                <Route path='*' element={<Navigate to='/error/404'/>}/>
            </Route>
        </Routes>
    )
}

const SuspensedView: FC = ({children}) => {
    const baseColor = getCSSVariableValue('--bs-primary')
    TopBarProgress.config({
        barColors: {
            '0': baseColor,
        },
        barThickness: 1,
        shadowBlur: 5,
    })
    return <Suspense fallback={<TopBarProgress/>}>{children}</Suspense>
}

export {PrivateRoutes}
